module.exports = __webpack_public_path__ + "static/new_shape-9c802a0539d2dff83aa6de8f436a00bd.png";